//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      isExpand: false
    }
  },
  created () {
    this.$vux.loading.hide()
  }
}



// WEBPACK FOOTER //
// ./src/components/Guide/appointmentConfStepGuide.vue